module.exports = __webpack_public_path__ + "static/phone@2x.e895deff.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/mini_portal/employee-engagement/phone@2x.png
// module id = 857
// module chunks = 153456355441848